import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const Client = () => {
const clients = [
  {
    image: "deniz.png",
    website: "https://dnz21.com/"
  },
  {
    image: "gemi1.png",
    website: "https://dnz21.com/"
  },
  {
    image: "banjovala.jpg",
    website: "https://banjovala.techbizsoftwaresolutions.com/"
  },
  {
    image: "FishterianzNewLogo.png",
    website: "https://fishterianz.com/"
  },
  {
    image: "vaishno-logo.png",
    website: "https://vaishno.techbizsoftwaresolutions.com/"
  },
  {
    image: "deniz.png",
    website: "https://dnz21.com/"
  },
  {
    image: "gemi1.png",
    website: "https://dnz21.com/"
  },
  {
    image: "banjovala.jpg",
    website: "https://banjovala.techbizsoftwaresolutions.com/"
  },
  {
    image: "FishterianzNewLogo.png",
    website: "https://fishterianz.com/"
  },
  {
    image: "vaishno-logo.png",
    website: "https://vaishno.techbizsoftwaresolutions.com/"
  }
];

const handleRedirect = (url) => {
  if (url) window.open(url, "_blank");
};

  return (
    <section id="clients" className="clients section light-background">
      <div className="container" data-aos="zoom-in">
       
        <Swiper
  modules={[Autoplay]}
  loop={true}
  speed={600}
  autoplay={{ delay: 3000, disableOnInteraction: false }}
  spaceBetween={30}
  breakpoints={{
    320: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 30
    },
    992: {
      slidesPerView: 5,
      spaceBetween: 40
    },
    1200: {
      slidesPerView: 6,
      spaceBetween: 50
    }
  }}
>
          {clients.map((client, index) => (
          <SwiperSlide key={index}>
            <div
              style={{ cursor: "pointer" }}
              onClick={() => handleRedirect(client.website)}
            >
              <img
                src={`/assets/img/clients/${client.image}`}
                alt={`Client ${index + 1}`}
                className="client-logo"
              />
            </div>
          </SwiperSlide>
        ))}
        </Swiper>

      </div>
    </section>
  );
};

export default Client;
